/**
 * 节点
 */
import Strategy from './sources/Strategy';
import StrategyBatch from './sources/StrategyBatch';
import Extraction from './sources/Extraction';

import Merge from './operations/Merge';
import Intersection from './operations/Intersection';
import Exclude from './operations/Exclude';
import Split from './operations/Split';
import DuplicateRemove from './operations/DuplicateRemove';

import SMS from './tasks/SMS';
import SaveCrowd from './tasks/SaveCrowd';

// import Coupon from './interest/Coupon';

import Graph from '@/utils/Graph';

/**
 * 加工节点
 * @param node 节点配置信息
 * @param type 节点类型 1-人群获取 2-人群操作 3-营销触点 4-客户权益
 */
const factory = (config, type = 1) => {
  // 这个节点类型的字符串会直接注册在G6里面
  const nodeType = `node-${config.info.name}-2`;
  Graph.registerNode({
    nodeType,
    iconText: config.info.iconText,
    type,
  });

  const info = {
    ...config.info,
    type,
    nodeType,
  };
  return {
    info,
    create(initData = {}) {
      console.log('initData', initData)
      const data = {
        ...config.data(),
        ...initData,
      };
      return {
        info,
        data,
        changeData(newData) {
          Object.assign(data, newData);
        },
        validators: config.validators,
        components: config.components,
        async validate() {
          return Promise.all(
            Object.keys(data)
              .filter((key) => key in this.validators)
              .map((key) => this.validators[key](data[key]))
          );
        },
      };
    },
  };
};

// 人群组件
const sourceNodes = [
  factory(Strategy, 1),
  factory(StrategyBatch, 1),
  factory(Extraction, 1)
];

// 操作组件
const operationNodes = [
  factory(Merge, 2),
  factory(Intersection, 2),
  factory(Exclude, 2),
  // factory(Split, 2),
  factory(DuplicateRemove, 2),
];

// 任务组件
const taskNodes = [
  factory(SMS, 3),
  // factory(SaveCrowd, 3),
];

// 所有组件集合
const allNodes = [
  ...sourceNodes,
  ...operationNodes,
  ...taskNodes,
];
export {
  sourceNodes,
  operationNodes,
  taskNodes,
  allNodes,
};

export default {
    // 人群组件
    sourceNodes,
    // 操作组件
    operationNodes,
    // 任务组件
    taskNodes,
};
